import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

function EliminarProductos({
  registro = {}, // { id, productoCodigo, productoDescripcion, tarjetaNumero, ... }
  onClose = () => {},
  onDeleted = () => {}, // callback para refrescar la grilla
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Campos visibles en el modal
  const productoCodigo = registro.productoCodigo ?? registro.codigo ?? "";
  const productoDescripcion =
    registro.productoDescripcion ?? registro.descripcion ?? "";
  const nroTarjeta =
    registro.tarjetaNumero ??
    registro.tarjeta ??
    registro.numeroTarjeta ??
    registro.numero ??
    "";

  // helper token (igual patrón que en la vista principal)
  const getAuthToken = () =>
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("access_token") ||
    sessionStorage.getItem("token") ||
    "";

  const handleDelete = async () => {
    if (!registro?.id) {
      setError("Falta el identificador del registro (PRTA_SQ_COD).");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const token = getAuthToken();
      await apiFetchJson(apiRoutes.productoTarjeta.delete(registro.id), {
        method: "DELETE",
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      onDeleted(registro); // avisa al padre para refrescar la lista
      onClose(); // cierra el modal
    } catch (e) {
      setError(e?.message || "No fue posible eliminar el registro.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Productos Tarjeta</h2>
      </div>

      {/* Body */}
      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm" style={{ color: "#1e72c0ff" }}>
          ¿Está seguro que desea eliminar este registro?
        </div>

        <div className="mb-2 bg-gray-50 px-6 py-6">
          <div className="text-center">
            <div className="mb-3">
              <span className="text-gray-500 mr-1">Producto:</span>
              <span className="value">
                {productoCodigo ? `${productoCodigo}  ` : ""}
                {productoDescripcion}
              </span>
            </div>
            <div>
              <span className="text-gray-500 mr-1">Tarjeta:</span>
              <span className="value">{nroTarjeta || "—"}</span>
            </div>
          </div>
        </div>

        {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
      </div>

      {/* Footer */}
      <div className="px-6 py-4 border-t flex items-center gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>
        <button className="btn-fil" onClick={onClose} disabled={loading}>
          Nueva consulta
        </button>
      </div>
    </div>
  );
}

export default EliminarProductos;
